import SolutionsDigitalTransformation from 'components/SolutionsDigitalTransformation/SolutionsDigitalTransformation'
import '../SolutionsPage.css'

const Digital = () => {
  return (
    <div>
      <SolutionsDigitalTransformation />
    </div>
  )
}

export default Digital
